var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _polygon, _circle, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 735.79999,
    height: 447.06565,
    viewBox: "0 0 735.79999 447.06565",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m582.01001,304.39564h-19.23999l-.07001-.07001c-3.41998-3.63-4.96002-8.73999-4.10999-13.64999.27002-1.59.78003-3.13,1.52002-4.57999l5.84998-11.45001-2.32001-41.00999c-.03998-.75999.21997-1.48.73999-2.03999.52002-.55,1.22998-.86,1.98999-.86h3.59998c1.47998,0,2.67999,1.16,2.73999,2.63l1.57001,40.53001,8.09998,12.66c.69,1.07999,1.25,2.23001,1.65002,3.42001,1.59003,4.60999,1.01001,9.62-1.59998,13.73999h0l-.42999.67001h.01001v.00995Z",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m580.34998,301.55564h0c-.17999.29001-.5.45999-.84003.45999h-14.64001c-.28003,0-.56-.12-.73999-.32999-2.46997-2.81-3.56-6.5-3.13-10.09.04999-.39001.34003-.72.71997-.82001,3.06-.81,6.75-1.26999,10.71997-1.26999,3.10999,0,6.03998.29001,8.64001.79999.35999.07001.65002.32999.75.67999,1.03998,3.51999.54999,7.38-1.46997,10.57001h-.00995Z",
    fill: "#0099ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m734.79999,313.06565H1c-.55,0-1-.45001-1-1s.45-1,1-1h733.79999c.54999,0,1,.45001,1,1s-.45001,1-1,1Z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-4d78f6fa-6618-4aff-a06a-080a1d9c45db-1103",
    d: "m215.45,127.32564c-10.75-3.22-17.81-11.38-15.75999-18.22,2.05-6.84,12.42999-9.78,23.17999-6.56,4.31,1.23,8.27,3.47,11.53999,6.54l45.39,14.21-7.12,21.16-43.99001-16.25999c-4.42.77-8.96001.47-13.24001-.88h0l.00002.00999Z",
    fill: "#a0616a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m416.79999,132.88564l.54999,37.37s-46.98001-.62-63.41998.67c-16.44,1.3-118.89-36.2-118.89-36.2l17.02-24.13,113.01999,27.28001,51.72-5h0v.00999Z",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 211.8,
    y: 82.06564,
    width: 7,
    height: 95.00001,
    fill: "#0099ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m244.07001,312.06565h-40.49001l-.14999-.16c-7.2-7.64999-10.44-18.38998-8.66-28.73001.57001-3.34,1.64-6.57999,3.2-9.63l12.32001-24.09-4.89-86.3c-.09-1.60001.47-3.12,1.57001-4.28s2.59-1.8,4.19-1.8h7.57001c3.11,0,5.64999,2.42999,5.77,5.53999l3.28999,85.3,17.06,26.64001c1.46001,2.28,2.63,4.70001,3.48,7.20001,3.34,9.70001,2.12,20.23999-3.36,28.91h0l-.89999,1.41h0l-.00002-.01001Z",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m240.59,306.09565h0c-.38.60001-1.05.97-1.77.97h-30.81999c-.59,0-1.17-.25-1.56-.69-5.2-5.92001-7.49001-13.67001-6.59-21.23001.10001-.82999.71001-1.51001,1.52-1.72,6.42999-1.70001,14.2-2.67999,22.56-2.67999,6.53999,0,12.72.60999,18.18001,1.67999.75.14999,1.37.69,1.58,1.42001,2.17999,7.39999,1.14999,15.53-3.10001,22.25h-.00002Z",
    fill: "#0099ff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "386.79999 80.06564 392.79999 121.06564 344.79999 126.06564 347.79999 73.06564 386.79999 80.06564",
    fill: "#a0616a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 341.17001,
    cy: 59.90564,
    r: 32.37,
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-01223ad5-4ac1-4a04-9d1d-d35e7b8f8b6b-1104",
    d: "m240.31,206.77564c-9.16-8.22-20.94-10.07001-26.32001-4.13s-2.32001,17.42,6.84,25.64c3.61,3.34,7.99001,5.74001,12.78,7.00999l39.25,34.33002,16.19-19.11-40.41-31.81c-1.75999-4.61-4.62-8.7-8.33-11.93001h.00002Z",
    fill: "#a0616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m347.79999,116.06564l49-7,29,22.00001,3,121,28,193-186,2s14-125,21-132,12-39,12-39l14-138s30-22,30-22.00001Z",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m329.29999,137.56565s-26-2-32,16-13,77-13,77l-16,2-14-15-15,36s53,58,73,32,17-148,17-148Z",
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m396.29999,76.61565s0-32.05,3-42.05-14-21-19-31-36,4-49,6-12,10-20,23,8,33,20,35,8,11,16.23001,21,34.53,0,34.53,0l3.23999,5s-7,28,6,52l34,9c-10-30,1-30,7.26999-45.5s-36.26999-32.45-36.26999-32.45Z",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m634.10999,303.38566h-17.82001v-29.88h17.82001c2.03003,0,3.65997-1.64999,3.65997-3.67999s-1.64001-3.64999-3.65997-3.66h-124.23999c-2.03,0-3.66,1.64999-3.66,3.67999s1.64001,3.64999,3.66,3.66h15.20001v29.88h-15.20001c-2.03,0-3.66,1.64999-3.66,3.67999s1.64001,3.64999,3.66,3.66h124.23999c2.03003,0,3.65997-1.64999,3.65997-3.67999s-1.64001-3.64999-3.65997-3.66h0Zm-101.70001,0l8.38-22.32001,68.15002-7.56v29.88h-76.53003Z",
    fill: "#f2f2f2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.6924932a440d2c4672cab08272a7f94b.svg";
export { ForwardRef as ReactComponent };